import { render, staticRenderFns } from "./Reauthorization.vue?vue&type=template&id=6ef035a8&scoped=true"
import script from "./Reauthorization.vue?vue&type=script&lang=ts"
export * from "./Reauthorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef035a8",
  null
  
)

export default component.exports